import { getNoBidClientStyle } from 'utils/helpers'

export const toCompaniesSelect = companies => {
  return companies.map(company => {
    return {
      value: company.id,
      label: company.name,
      color: getNoBidClientStyle(company.noBid).color
    }
  })
}

export const toCompaniesRowData = companies =>
  companies.map(company => {
    const { numberOfLostDeals, numberOfOpenDeals, numberOfWonDeals } = company
    return {
      ...company,
      lostDeals: numberOfLostDeals,
      openDeals: numberOfOpenDeals,
      wonDeals: numberOfWonDeals
    }
  })

export const toCompanyFormData = (company, file) => {
  const {
    name,
    legalName,
    description,
    address,
    address2,
    street2,
    city,
    state,
    zipcode,
    country,
    phone,
    additionalPhone,
    fax,
    website,
    email,
    emailDomain,
    types,
    size,
    preQualified,
    preQualifiedExpDate,
    facebook,
    linkedin,
    twitter,
    instagram,
    youtube,
    noBid,
    noBidReasonId,
    noBidReasonDescription,
    segment,
    parentCompany,
    label
  } = company

  const formData = new FormData()
  const companyData = {
    ...(name ? { name } : {}),
    ...(label ? { label } : {}),
    ...(legalName ? { legalName } : {}),
    ...(description ? { description } : {}),
    ...(address ? { address } : {}),
    ...(address2 ? { address2 } : {}),
    ...(street2 ? { street2 } : {}),
    ...(city ? { city } : {}),
    ...(state ? { state } : {}),
    ...(country ? { country } : {}),
    ...(zipcode ? { zipcode } : {}),
    ...(phone ? { phone } : {}),
    ...(additionalPhone ? { additionalPhone } : {}),
    ...(fax ? { fax } : {}),
    ...(website ? { website } : {}),
    ...(email ? { email } : {}),
    ...(emailDomain ? { emailDomain } : {}),
    ...(types?.length ? { types: types.map(type => type.value) } : []),
    ...(size?.value ? { size: size.value } : {}),
    ...(segment?.value ? { segmentId: segment.value } : {}),
    ...(parentCompany?.value ? { parentId: parentCompany.value } : {}),
    ...(preQualified !== undefined ? { preQualified } : {}),
    ...(preQualifiedExpDate ? { preQualifiedExpDate } : {}),
    ...(facebook ? { facebook } : {}),
    ...(instagram ? { instagram } : {}),
    ...(linkedin ? { linkedin } : {}),
    ...(twitter ? { twitter } : {}),
    ...(youtube ? { youtube } : {}),
    ...(noBid ? { noBid } : {}),
    ...(noBidReasonId ? { noBidReasonId } : {}),
    ...(noBidReasonDescription ? { noBidReasonDescription } : {})
  }

  formData.append('companyData', JSON.stringify(companyData))
  file && formData.append('file', file)

  return formData
}
